import { useSelector } from 'react-redux';

import { AppState } from '@redux/store';
import { isClientOrgType } from 'enum/combobox';

// Nhận diện vai trò theo `code` — khóa ngữ nghĩa cố định (seed giống nhau mọi môi trường),
// KHÔNG phụ thuộc tên (drift/mojibake) hay UUID (có thể khác giữa prod và env khác). BE trả
// `code` trong payload role-assignment (cột roles.code).
const NUTRI_BAD_CODE = 'NUTRI_BAD';
export const RAD_CODE = 'RAD';
const SAD_CODE = 'SAD';
const CS_BAD_CODE = 'CS_BAD';

/**
 * Lấy roles của người dùng đang đăng nhập.
 * Dữ liệu từ Redux auth.userRoles, được fetch bởi UserController_getRoleAssignments
 * khi login -> GET /authen-user/role-assignment
 */
const useUserRoles = () => {
  const { userRoles, userInfo } = useSelector(({ auth }: AppState) => auth);

  const systemRoles = userRoles.systemRoles || [];
  const adminRoles = userRoles.adminRoles || [];

  // sample: [KH-DVBC1-TH]
  const clientsOfCSBAD = adminRoles.reduce((acc, next) => {
    if (next.adminRole.code !== CS_BAD_CODE) return acc;
    return [...acc, next.targetOrgId];
  }, [] as string[]);

  // sample: [KH-DVBC1-TH]
  const clientsOfNutriBAD = adminRoles.reduce((acc, next) => {
    if (next.adminRole.code !== NUTRI_BAD_CODE) return acc;
    return [...acc, next.targetOrgId];
  }, [] as string[]);

  /**
   * Tập hợp khách hàng chỉ có quyền xem mà không chỉnh sửa
   */
  const viewOnlyClients = clientsOfNutriBAD.filter((client) => !clientsOfCSBAD.includes(client));

  const isRAD = !!systemRoles.find((r) => r.systemRole.code === RAD_CODE);
  const isSAD = !!systemRoles.find((r) => r.systemRole.code === SAD_CODE);
  const isCSBAD = !!adminRoles.find((r) => r.adminRole.code === CS_BAD_CODE);
  const isNutriBAD = !!adminRoles.find((r) => r.adminRole.code === NUTRI_BAD_CODE);

  const isAbleToAddOrEdit = isRAD || isSAD || isCSBAD;

  // Xét theo LOẠI đơn vị của tài khoản, KHÔNG cắt tiền tố mã CĐS: mã khách hàng giờ là `HSKD-*`
  // (KIOS đổi bộ mã) nên cách cũ so với 'KH' luôn trả về false. Bản đồ (NewMap) và Dashboard vốn
  // đã xét theo userActualManagingOrgType — đây là chỗ còn sót. Xem isClientOrgType.
  const isClient = isClientOrgType(userInfo?.userAuthen?.userActualManagingOrgType);

  return {
    isRAD,
    isSAD,
    isCSBAD,
    /**
     * nếu là nutri BAD thì sẽ bị hạn chế một số quyền
     */
    isNutriBAD,
    isClient,
    isAbleToAddOrEdit,
    clientsOfCSBAD,
    viewOnlyClients,
  };
};

export default useUserRoles;
